module.exports = __webpack_public_path__ + "img/back-dark_fc35f.png";